import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { OverlayLoader, PageError, UiToggle, PageHeader, UiTFind, BgLoader, TableZero, UiButton, InLoader, UiActioButton, UiDatePicker, UiInput } from "../../ui";
import { NavLink, useNavigate, useParams, useLocation, Outlet, useOutletContext } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Helmet } from "react-helmet";
import { GoPlus } from "react-icons/go";



export function ComplianceGenSettings() {
  const [pstate, setPState] = useOutletContext();
  const navigate = useNavigate()
  const [state, setState] = useState({});
  const schema = yup.object().shape({
    show_practive_compliances: yup.bool(),

  }, []);
  const {
    register,
    handleSubmit,
    control,
    watch,
    getValues,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {
    handleSave();
  };
  var handleSave = (e) => {
    setState({ ...state, loader: true });
    var form = document.querySelector("#compliancessettingsfrm");
    var data = new FormData(form);

    instance({
      method: "post",
      url: "/update_compliance_settings",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setState({ ...state, loader: false });
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.status == "success") {

          toast(response.data.msg, { type: "success" });

        }
      })
      .catch(function (response) { });
  };

  useEffect(() => {
    instance
      .get("/compliance_calender_settings")
      .then(function (response) {
        setState({ ...state, ...response.data });
        reset({ ...response.data.settings });
      })
      .catch(function (error) { })
      .then(function () { });
  }, []);

  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }
  return (
    <div>
      {state.settings ? (
        <form id="compliancessettingsfrm" onSubmit={handleSubmit(onSubmitHandler)} noValidate>

          <div className="card card-default mb-4">
            <div className="card-body">

              <UiToggle
                id="show_practive_compliances"
                name="show_practive_compliances"
                title="Show compliances provided by Practive Automation"
                {...register("show_practive_compliances")}
              />



            </div>

          </div>

          <UiButton loading={state["loader"]} title="Save" />
        </form>
      ) : <BgLoader />}
    </div>
  )

}

export default function CompliancesSettings() {
  let { id } = useParams();
  const [state, setState] = useState({});
  const [loader, showLoader] = useState(false);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }


  return (
    <>
      <Helmet>

        <title>
          Compliance Calendar Settings | Practive
        </title>


      </Helmet>
      <div>
        <div>
          <PageHeader title='Compliance Calendar Settings' parent="Settings" link="/settings">

          </PageHeader>


          <div className="tabs mb-3">

            <NavLink to="" end className="tab-itm">General Settings</NavLink>
            <NavLink to="acts" className="tab-itm">Acts</NavLink>
            <NavLink to="custom-events" className="tab-itm">Custom Events</NavLink>
          </div>

          <Outlet context={[state, setState]} />


        </div>

        <OverlayLoader visible={loader} />

      </div>
    </>

  );
}

